// extracted by mini-css-extract-plugin
export default {"heading":"RequestTypeForm_heading__Z2blC","subHeading":"RequestTypeForm_subHeading__UxmyA","listItem":"RequestTypeForm_listItem__KiohT","input":"RequestTypeForm_input__GFrgo"};